const BankConfirmationModal = ({
  onClose,
  onConfirm,
  selectedBanks = [], // Default to empty array
  selectedRepresentatives = [], // Default to empty array
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center overflow-y-auto">
      <div className="bg-[#131313] rounded-lg w-full max-w-2xl p-6 relative max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-2">
            <svg
              className="w-6 h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <h2 className="text-white text-xl font-medium">
              Bank & Representative Confirmation
            </h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Selected Banks Section */}
        <div className="mb-6">
          <h3 className="text-[#FFCA20] text-sm font-medium mb-3">
            SELECTED BANKS
          </h3>
          <div className="space-y-2">
            {selectedBanks.length > 0 ? (
              selectedBanks.map((bank, index) => (
                <p key={index} className="text-white">
                  {bank.name}
                  {bank.branch ? `, ${bank.branch}` : ""}
                  {bank.city ? `, ${bank.city}` : ""}
                </p>
              ))
            ) : (
              <p className="text-gray-400">No banks selected.</p>
            )}
          </div>
        </div>

        {/* Selected Representatives Section */}
        <div className="mb-8">
          <h3 className="text-[#FFCA20] text-sm font-medium mb-3">
            SELECTED REPRESENTATIVES
          </h3>
          <div>
            {selectedRepresentatives.length > 0 ? (
              selectedRepresentatives.map((rep, index) => (
                <p key={index} className="text-white">
                  <span className="font-medium">{rep.name}</span>
                  {rep.details && (
                    <span className="text-gray-400"> - {rep.details}</span>
                  )}
                </p>
              ))
            ) : (
              <p className="text-gray-400">No representatives selected.</p>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-between">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-800 text-white rounded hover:bg-gray-700 transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={onConfirm}
            className="px-6 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition-colors flex items-center gap-2"
          >
            Confirm
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BankConfirmationModal;
